import { Pill } from '@/components/ui/pill'

/**
 * Story 32.1 — o selo do ambiente de staging, ao lado da marca (no trilho e no
 * cabeçalho do celular), para ninguém trabalhar no ambiente errado sem dar por
 * isso. Só o staging se marca: em produção, e numa build local (`dev`), não
 * renderiza nada.
 *
 * `warn` e não `info`: o selo avisa que o que se faz aqui não é a sério.
 * Mapeador sobre o `Pill`, e não um primitivo novo.
 *
 * O ambiente vem de `VITE_APP_ENV`, que o deploy passa à build (vite.config.ts).
 */
export function EnvironmentPill() {
  if (import.meta.env.VITE_APP_ENV !== 'staging') return null
  return <Pill variant="warn">Staging</Pill>
}
